export function nextAvailableChatId(
    existingChats: Record<string, unknown>,
    lastReservedId: number,
    now: number = Date.now(),
): number {
    // Chat IDs and reservation values are integer timestamps. Flooring makes
    // the next integer after a defensive fractional input explicit.
    const highestExistingId = Object.keys(existingChats).reduce((highest, key) => {
        const id = Number(key);
        return Number.isSafeInteger(id) ? Math.max(highest, id) : highest;
    }, 0);

    return Math.max(
        Math.floor(now),
        Math.floor(lastReservedId) + 1,
        highestExistingId + 1,
        1,
    );
}
